/* eslint-disable react/prop-types */
import { ListSubheader, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, createContext, forwardRef, useContext, Children, } from 'react';
import { VariableSizeList } from 'react-window';
const LISTBOX_PADDING = 8;
const OuterElementContext = createContext({});
const OuterElementType = forwardRef((props, ref) => {
    const outerProps = useContext(OuterElementContext);
    return React.createElement("div", { ref: ref, ...props, ...outerProps });
});
OuterElementType.displayName = 'OuterElementType';
const useResetCache = (data) => {
    const ref = React.useRef(null);
    useEffect(() => {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
};
const ListBox = forwardRef(function ListBox({ children, ...other }, ref) {
    const itemData = Children.toArray(children);
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
    const itemCount = itemData.length;
    const itemSize = smUp ? 36 : 48;
    const getChildSize = (child) => {
        if (React.isValidElement(child) && child.type === ListSubheader) {
            return 48;
        }
        return itemSize;
    };
    const getHeight = () => {
        if (itemCount > 8) {
            return 8 * itemSize;
        }
        return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
    };
    const gridRef = useResetCache(itemCount);
    const renderRow = (props) => {
        const { data, index, style } = props;
        return React.cloneElement(data[index], {
            style: {
                ...style,
                top: LISTBOX_PADDING + Number(style.top ?? 0),
            },
        });
    };
    return (React.createElement("div", { ref: ref },
        React.createElement(OuterElementContext.Provider, { value: other },
            React.createElement(VariableSizeList, { height: getHeight() + 2 * LISTBOX_PADDING, innerElementType: "ul", itemCount: itemCount, itemData: itemData, itemSize: index => getChildSize(itemData[index]), outerElementType: OuterElementType, overscanCount: 5, ref: gridRef, width: "100%" }, renderRow))));
});
export default ListBox;
